import React, { useRef, createContext } from "react";

export const RefContext = createContext(undefined);

export const RefProvider = ({ children }) => {
  const componentSize = useRef({});
  const storedValueRef = useRef(null);
  const storedValueSelections = useRef({
    currentTicker: "",
    currentHorizon: "",
  });

  const refs = {
    componentSize,
    storedValueRef,
    storedValueSelections,
  };

  return refs ? (
    <RefContext.Provider value={refs}>{children}</RefContext.Provider>
  ) : null;
};
